
/**
 * checkBruehmengeEditOpen
 * @param sectionID
 * @returns {boolean}
 */
window.checkBrueheHerbizidEditOpen = function (sectionID) {
  const tableBerechnungBrueheHerbizid = $('#table-berechnungBrueheHerbizid');
  const checkedData = tableBerechnungBrueheHerbizid.find('.check-section:checked');

  if (checkedData.length > 1) {
    ajaxDialog(BASE_PATH + 'ajax/dialog/betriebsdaten/ajax.editAusliterungBehandelteFlaeche', 350, { post_data: { data: getCheckedData(checkedData) } });
  } else {
    window.location = BASE_PATH + 'betriebsdaten/berechnungBrueheHerbizidEdit/' + sectionID;
  }

  return false;
};